import { TestsResults } from '@pyodide/models/tests.model';

// https://docs.pytest.org/en/7.1.x/reference/reference.html?highlight=exitcode#pytest.ExitCode
enum EXIT_CODE {
  OK = 0, // Tests passed.
  TESTS_FAILED = 1, // Tests failed.
  INTERRUPTED = 2, // pytest was interrupted
  INTERNAL_ERROR = 3, // An internal error got in the way.
  USAGE_ERROR = 4, // pytest was misused.
  NO_TESTS_COLLECTED = 5, // pytest couldn’t find tests.
}

type Tests = Array<Map<string, unknown>>;

export const parsePyTestJsonReportToObj = (mapReport: Map<string, unknown>): TestsResults => {
  const exitcode = mapReport.get('exitcode') as number;
  switch (exitcode) {
    case EXIT_CODE.OK: {
      return {
        specs: {
          result: {
            path: 'path',
            tests: getSummaryTests(mapReport.get('tests') as Tests),
          },
        },
        status: 'success',
      };
    }
    case EXIT_CODE.TESTS_FAILED: {
      return {
        specs: {
          result: {
            path: 'path',
            tests: getSummaryTests(mapReport.get('tests') as Tests),
          },
        },
        status: 'fail',
      };
    }
    case EXIT_CODE.INTERRUPTED: {
      const collectors = mapReport.get('collectors') as Tests;
      return {
        specs: {
          result: {
            path: 'path',
            tests: getCollectorsTests(collectors),
          },
        },
        status: 'fail',
      };
    }
    default: {
      return {
        specs: {},
        status: 'init',
      };
    }
  }
};

const getSummaryTests = (tests: Tests) => {
  return tests
    .filter((test) => test.get('nodeid') !== '')
    .map((test) => {
      const nodeId = (test.get('nodeid') as string).split('::');
      const [path, name] = nodeId;
      const status = test.get('outcome') === 'passed' ? 'pass' : 'fail';
      const errors = [];
      if (status === 'fail') {
        const call = test.get('call') as Map<string, unknown>;
        const crash = call.get('crash') as Map<string, unknown>;
        errors.push(crash.get('message'));
      }
      return {
        name,
        status,
        path,
        errors,
        syntaxErrors: [],
      };
    })
    .reduce(
      (obj, test) => ({
        ...obj,
        [test.name]: test,
      }),
      {}
    );
};

const getCollectorsTests = (tests: Tests) => {
  return tests
    .filter((test) => test.get('nodeid') !== '')
    .map((test) => {
      const nodeId = test.get('nodeid') as string;
      const error = test.get('longrepr') as string;
      return {
        name: nodeId,
        status: 'fail',
        path: nodeId,
        errors: [],
        syntaxErrors: [error],
      };
    })
    .reduce(
      (obj, test) => ({
        ...obj,
        [test.name]: test,
      }),
      {}
    );
};
